import { makeStyles } from '@material-ui/core/styles'
import { getOutlinedTextFieldWrapperStyles } from 'lib/form-field-styles'

const useAccountDetailsStyles = makeStyles(theme => ({
  contentContainer: {
    margin: '2rem auto 6rem',
    maxWidth: 832,
    padding: theme.spacing(0, 2),
  },
  stack: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
  card: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2.5, 3, 2),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 2, 1.5),
    },
  },
  cardTitle: {
    fontWeight: 700,
    fontSize: '1.125rem',
    lineHeight: 1.3,
    color: '#00205B',
  },
  cardDivider: {
    height: 1,
    backgroundColor: '#E0E0E0',
  },
  cardContent: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
      gap: theme.spacing(2),
    },
  },
  avatar: {
    width: 72,
    height: 72,
    fontSize: '1.25rem',
    fontWeight: 700,
    color: '#00205B',
    backgroundColor: '#E8F1FF',
    textTransform: 'uppercase',
    border: '2px solid #E0E0E0',
    boxSizing: 'border-box',
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  fieldLabel: {
    fontWeight: 700,
    fontSize: '0.9375rem',
    lineHeight: 1.3,
    color: '#00205B',
  },
  fieldCaption: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  accountField: {
    ...getOutlinedTextFieldWrapperStyles(theme),
  },
  membershipCaption: {
    fontSize: '0.8125rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
  },
  membershipGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  membershipStat: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75),
    padding: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: '#F4F7F9',
    minHeight: 72,
  },
  membershipStatLabel: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.06em',
    lineHeight: 1.3,
    textTransform: 'uppercase',
    color: '#6B7C87',
  },
  membershipStatValue: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.3,
    color: '#00205B',
    wordBreak: 'break-word',
  },
  refreshButton: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.875rem',
    color: '#00205B',
    padding: theme.spacing(0.5, 1),
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(0.75),
    },
  },
  saveActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
  },
  saveError: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.error.main,
  },
  saveButton: {
    borderRadius: 20,
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '0.9375rem',
    padding: theme.spacing(1.25, 3.5),
    boxShadow: 'none',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 83, 255, 0.28)',
    },
  },
  saveButtonInactive: {
    color: '#6B7C87',
    backgroundColor: '#EBF0F2',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#EBF0F2',
      boxShadow: 'none',
    },
    '&.Mui-disabled': {
      color: '#9EA7B0',
      backgroundColor: '#EBF0F2',
    },
  },
}))

export default useAccountDetailsStyles
